"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSlots = getSlots;
const stentor_guards_1 = require("stentor-guards");
/**
 * Helper method to get the slots from the request, regardless of the type of request
 *
 * @param request
 * @returns
 */
function getSlots(request) {
    let slots;
    if ((0, stentor_guards_1.isIntentRequest)(request)) {
        slots = request.slots;
    }
    return slots;
}
//# sourceMappingURL=getSlots.js.map